import {
  FormFieldWidget,
  isValidatorSuccess,
  ModelFieldType,
  SPI,
  ValidateTrigger,
  ViewType,
  Widget,
  WidgetTrigger
} from '@kunlun/dependencies';
import EnterToTrigger from './EnterToTrigger.vue';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Form,
    ttype: ModelFieldType.String,
    widget: 'EnterToTrigger',
    multi: false
  })
)
export class FormStringEnterToTriggerFieldWidget extends FormFieldWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent(EnterToTrigger);
    return this;
  }

  @Widget.Method()
  public onEnter() {
    if (this.validateTrigger.includes(ValidateTrigger.CHANGE)) {
      this.executeValidator().then((info) => {
        if (isValidatorSuccess(info)) {
          this.afterChange();
        }
      });
    } else {
      this.afterChange();
    }
  }

  protected afterChange() {
    this.afterTriggerExecute(WidgetTrigger.BLUR);
  }

  public change(val: unknown) {
    this.setValue(val);
  }
}
